import { DialogWithForm } from '@strata/react-dialog';
import { InlineMessage } from '@strata/react-inline-message';
import { ServicingRate } from '@strata/react-servicing-rate';
import Decimal from 'decimal.js';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { BidTermsAndConditionsCheckbox } from 'components/shared/BidTermsAndConditionsCheckbox';
import { ProspectiveReferralInlineMessage } from 'components/shared/ProspectiveReferralInlineMessage';
import { ReferralDetails } from 'store/api/treatmentApi';
import { LiveReferral } from 'store/liveReferrals/liveReferralsHooks';

interface BidConfirmationDialogProps {
    isOpen: boolean;
    onSecondaryButtonClick: () => void;
    onSubmit: () => void;
    maxBid?: number;
    selectedReferral?: LiveReferral;
    referralDetails?: ReferralDetails;
    auctionEnded: boolean;
    hasPreviouslyBidOnReferral?: boolean;
}

export const BidConfirmationDialog = ({
    isOpen,
    onSecondaryButtonClick,
    onSubmit,
    maxBid = 0,
    selectedReferral = undefined,
    referralDetails = undefined,
    auctionEnded,
    hasPreviouslyBidOnReferral = false,
}: BidConfirmationDialogProps) => (
    <Formik
        initialValues={{
            ...BidTermsAndConditionsCheckbox.initialValues(hasPreviouslyBidOnReferral),
        }}
        enableReinitialize
        validateOnMount
        validationSchema={Yup.object({
            ...BidTermsAndConditionsCheckbox.validationSchema,
        })}
        onSubmit={(_values, { resetForm }) => {
            onSubmit();
            resetForm();
        }}
    >
        {(formik) => (
            <DialogWithForm
                dialogTitle="Confirm Bid"
                width={670}
                isOpen={isOpen}
                secondaryButtonLabel="Cancel"
                onSecondaryButtonClick={() => {
                    formik.handleReset();
                    onSecondaryButtonClick();
                }}
                primaryButtonLabel="Confirm Bid"
                isPrimaryButtonDisabled={auctionEnded || !formik.isValid}
                focusPrimaryButton={hasPreviouslyBidOnReferral}
                dialogContent={
                    <div className="flex__gap--medium" style={{ flexDirection: 'column' }}>
                        <div>
                            You have access to this drug and are agreeing to service this referral
                            for up to 1 year at:
                        </div>
                        <ServicingRate
                            servicingRate={Decimal.div(Number(maxBid), 100).toNumber()}
                            referentPriceType={selectedReferral?.referentPriceType}
                        />
                        <ProspectiveReferralInlineMessage
                            referralStart={referralDetails?.referralStart}
                            outreachDate={referralDetails?.outreachDate}
                        />
                        {selectedReferral?.priceIsFrozen && (
                            <InlineMessage
                                wrapText
                                intent={InlineMessage.Intent.INFO}
                                label="Servicing unit price will be locked at the servicing start date for the life of this referral."
                            />
                        )}
                        <BidTermsAndConditionsCheckbox />
                    </div>
                }
            />
        )}
    </Formik>
);
